import src from "IMAGE";
export default { src, width: 120, height: 120, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
